import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/location.png'


const _withScopeId = n => (_pushScopeId("data-v-0a3bf423"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-[1200px] mx-auto pb-[20px] px-60px box-sizing building-list page-building" }
const _hoisted_2 = { class: "flex py-[20px] text-[14px] text-[#606266]" }
const _hoisted_3 = { class: "path" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "location",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "当前位置:", -1))
const _hoisted_6 = { class: "bg-white pt-[40px]" }
const _hoisted_7 = {
  key: 0,
  class: "flex p-[60px] building-impor-wrap"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "w-[100%] bg-black/50 absolute z-10 bottom-0 h-[50px] text-white flex items-center justify-between" }
const _hoisted_10 = { class: "flex items-end justify-center overflow-hidden pb-[6px]" }
const _hoisted_11 = { class: "text-[20px] text-[var(--el-color-primary)]" }
const _hoisted_12 = { class: "mr-[8px]" }
const _hoisted_13 = { class: "inline-block overflow-hidden text-ellipsis whitespace-nowrap" }
const _hoisted_14 = { class: "w-[50%] ml-[40px] building-impor-typewrap" }
const _hoisted_15 = { class: "text-[20px] text-[#333] leading-[20px] text-ellipsis overflow-hidden whitespace-nowrap" }
const _hoisted_16 = { class: "mt-[26px]" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "flex-1 overflow-hidden whitespace-nowrap text-ellipsis" }
const _hoisted_19 = {
  key: 1,
  class: "building-impor-loog mb-[60px] w-[1080px] h-[97px] bg-[url('@/assets/images/center.png')] bg-auto mx-auto"
}
const _hoisted_20 = { class: "flex flex-wrap pb-[20px] px-[60px] justify-between building-impor-list" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "mt-[26px]" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "flex-1 overflow-hidden whitespace-nowrap text-ellipsis" }

import { ref, onMounted, watch } from "vue";
import useNavigation from "@/hooks/useNavigation";
import { getPage } from "@/http/api/index";
import gqbanner from "@/assets/images/gqbanner.png";
import useCurName from "@/hooks/useCurMenu";
import useGetNewsNavList from "@/hooks/useGetNewsNavList";
interface IRightItem {
  title: string;
  id: string;
  banner: string;
  children?: Array<IRightItem>;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BuildingList',
  setup(__props) {

const activeIndex = ref(0);
const Loading = ref(false)
function changeIndex(num) {
  activeIndex.value += num;
  if (activeIndex.value < 0) {
    activeIndex.value = leftList.value.length - 1;
  } else if (activeIndex.value >= leftList.value.length) {
    activeIndex.value = 0;
  }
}
const typeList = ref<Array<IRightItem>>([]);
// 轮播数据
const leftList = ref<Array<IRightItem>>([]);
const rightList = ref<Array<IRightItem>>([]);
const { push } = useNavigation();
const { name } = useCurName("/partyBuilding");
function goSecond({ id }) {
  push({
    path: "/partyBuilding/second",
    query: {
      id,
    },
  });
}
const { getNewsInfo } = useGetNewsNavList<{ type: string }>(
  "/partyBuilding",
  pullData,
  [
    // {
    //   type: "0",
    // },
    {
      type: "1",
    },
  ]
);
function pullData(res) {
  // const topList = res.data[0].data.leftList;
  // if (topList.length > 0) {
  //   getPage({ pageNum: 1, pageSize: 3, menuId: topList[0].id }).then((res) => {
  //     leftList.value = res.rows;
  //   });
  //   rightList.value = topList.slice(1, 3);
  //   Promise.all(
  //     rightList.value.map((item) =>
  //       getPage({ pageNum: 1, pageSize: 3, menuId: item.id })
  //     )
  //   ).then((res) => {
  //     rightList.value.forEach((item, index) => {
  //       item.children = res[index].rows;
  //       console.log(res[index]);
  //     });
  //   });
  // }

  // typeList.value = res.data[1].data.leftList || [];
  Loading.value = true
  typeList.value = res.data[0].data.leftList || [];
  Promise.all(
    typeList.value.map((item) =>
      getPage({ pageNum: 1, pageSize: 4, menuId: item.id })
    )
  ).then((res) => {
    typeList.value.forEach((item, index) => {
      item.children = res[index].rows;
    });
  }).finally(() => {
    Loading.value = false
  });
}

function goDetail({ id }) {
  push({
    path: "/partyBuilding/detail",
    query: {
      id,
    },
  });
}
onMounted(() => {
  getNewsInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("span", null, [
          _createVNode(_component_el_link, {
            to: "/",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(push)('/')))
          }, {
            default: _withCtx(() => [
              _createTextVNode("首页")
            ]),
            _: 1
          }),
          _createTextVNode(" > " + _toDisplayString(_unref(name)), 1)
        ])
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", {
              class: "w-50% relative building-impor-gg",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (goDetail(leftList.value[activeIndex.value])))
            }, [
              _createElementVNode("img", {
                class: "w-[100%]",
                src: leftList.value[activeIndex.value]?.banner || _unref(gqbanner)
              }, null, 8, _hoisted_8),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("i", {
                  class: "iconfont icon-xiangxiajiantou transform rotate-90 cursor-pointer ml-[8px]",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (changeIndex(-1)), ["stop"]))
                }),
                _createElementVNode("span", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(activeIndex.value + 1), 1),
                  _createTextVNode("/"),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(leftList.value.length), 1),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(leftList.value[activeIndex.value]?.title), 1)
                ]),
                _createElementVNode("i", {
                  class: "iconfont icon-xiangxiajiantou transform rotate-[-90deg] cursor-pointer mr-[8px]",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (changeIndex(1)), ["stop"]))
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rightList.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id
                }, [
                  _createElementVNode("p", _hoisted_15, _toDisplayString(item.title), 1),
                  _createElementVNode("ul", _hoisted_16, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (demo) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "doc",
                        key: demo.id,
                        onClick: ($event: any) => (goDetail(demo))
                      }, [
                        _createElementVNode("span", _hoisted_18, _toDisplayString(demo.title), 1)
                      ], 8, _hoisted_17))
                    }), 128))
                  ]),
                  (index != rightList.value.length - 1)
                    ? (_openBlock(), _createBlock(_component_el_divider, { key: 0 }))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true),
      false
        ? (_openBlock(), _createElementBlock("div", _hoisted_19))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_20, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(typeList.value, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: "list-li pb-[60px]"
          }, [
            _createElementVNode("p", {
              class: "text-ellipsis overflow-hidden whitespace-nowrap text-[18px] cursor-pointer leading-[18px] text-[var(--el-color-primary)] pb-[12px] border-b-[1px]",
              onClick: ($event: any) => (goSecond(item))
            }, _toDisplayString(item.title), 9, _hoisted_21),
            _createElementVNode("ul", _hoisted_22, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (demo) => {
                return (_openBlock(), _createElementBlock("li", {
                  class: "doc",
                  key: demo.id,
                  onClick: ($event: any) => (goDetail(demo))
                }, [
                  _createElementVNode("span", _hoisted_24, _toDisplayString(demo.title), 1)
                ], 8, _hoisted_23))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ])), [
      [_directive_loading, Loading.value]
    ])
  ]))
}
}

})